import { render, staticRenderFns } from "./DataFilterVertical.vue?vue&type=template&id=34a4fc03&"
import script from "./DataFilterVertical.vue?vue&type=script&lang=js&"
export * from "./DataFilterVertical.vue?vue&type=script&lang=js&"
import style0 from "./DataFilterVertical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports